/* tslint:disable:max-line-length */
import {Injectable} from '@angular/core';
import {distinctUntilChanged, filter, firstValueFrom} from 'rxjs';
import {MmProjectService} from '../../../mm-project/mm-project.service';
import {MmFaultFormService} from '../mm-fault-form.service';
import {MmProjectLoaderService} from '../../../mm-project/mm-project-loader.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {MmModel} from '@docma-mm-core/model/mm.model';
import {FieldMinimal} from '@docma-mm-core/field/field';

@UntilDestroy()
@Injectable()
export class MmFaultPinService {

  private fieldKeyToIdMap = new Map<string, number>();

  constructor(private readonly projectService: MmProjectService,
              public readonly projectLoaderService: MmProjectLoaderService,
              private readonly faultFormService: MmFaultFormService) {

    this.projectLoaderService.fields.pipe(untilDestroyed(this), filter(Boolean), distinctUntilChanged()).subscribe(async fields => {
      await this.initialize(fields);
    });

  }

  async initialize(fieldsModel: MmModel<FieldMinimal[]>) {
    this.fieldKeyToIdMap.clear();

    const fieldGroups = this.faultFormService.getFaultFieldGroups(fieldsModel.data);
    const fieldsInternal = [...fieldGroups.descriptionFields.concat(fieldGroups.executionFields, fieldGroups.responsibleFields, fieldGroups.classificationFields, fieldGroups.projectFields, fieldGroups.costFields)];
    const allFields = Object.fromEntries(fieldsInternal.map(m => [m.Prop, m]));

    for (const [key, field] of Object.entries(allFields)) {
      this.fieldKeyToIdMap.set(key, field.FieldId);
    }

  }

  // Method to get the pin text value based on the field
  public async getPinTextValue(field: { [key: string]: any }) {
    const project = await firstValueFrom(this.projectService.currentProject);

    if (!project || !project.textPinEnabled || !project.textPinFieldId) {
      return;
    }

    const fieldId = project.textPinFieldId;

    if (field) {
      for (const [key, value] of Object.entries(field)) {
        if (this.fieldKeyToIdMap.get(key) === +fieldId) {
          return {[key]: value};
        }
      }
    }
    return null;
  }

}
